// src/pages/Userpanel/MyTask.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const TOTAL_ADS = 250; // মোট ads সংখ্যা

const MyTask = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [timeLeft, setTimeLeft] = useState({}); // countdown timer for each ad

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          setLoading(false);
          return;
        }

        const res = await axios.get("https://api.earnmoney0.top/api/user/me", {
          headers: { Authorization: `Bearer ${token}` },
        });

        setUser(res.data);
      } catch (err) {
        console.error("Fetch user error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  // 🔐 FINAL & SAFE UNLOCK CALCULATION
  const calculateUnlockedAds = () => {
    if (!user) return 1;

    if (!user.package || user.package === "free") return 1;

    const now = Date.now();
    let maxUnlocked = 1;

    if (Array.isArray(user.adsUnlockData)) {
      user.adsUnlockData.forEach((item) => {
        if (item.expiresAt && new Date(item.expiresAt).getTime() > now) {
          if (typeof item.endIndex === "number" && item.endIndex > maxUnlocked) {
            maxUnlocked = item.endIndex;
          }
        }
      });
    }

    return maxUnlocked;
  };

  const unlockedAdsCount = calculateUnlockedAds();

  // 🔥 Countdown Timer for Complete 🔒 ads
  useEffect(() => {
    const interval = setInterval(() => {
      if (!user) return;

      const now = new Date();
      const midnight = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() + 1,
        0, 0, 0, 0
      ).getTime();

      const newTimeLeft = {};

      user.adsCompleted?.forEach((adId) => {
        const lastCompleteTime = new Date(user.adsCompletedTimes?.[adId] || 0).getTime();
        // only show countdown if completed today
        if (lastCompleteTime < midnight) {
          const diffMs = midnight - now.getTime();
          const hours = Math.floor(diffMs / (1000 * 60 * 60));
          const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);
          newTimeLeft[adId] = `${hours.toString().padStart(2,'0')}:${minutes.toString().padStart(2,'0')}:${seconds.toString().padStart(2,'0')}`;
        }
      });

      setTimeLeft(newTimeLeft);
    }, 1000);

    return () => clearInterval(interval);
  }, [user]);

  const handleViewAds = (adId) => {
    navigate(`/my-task/${adId}`, { state: { adId } });
  };

  if (loading) {
    return <div style={{ padding: 20 }}>Loading Ads...</div>;
  }

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <h3>My Task</h3>
      </div>

      <div style={styles.list}>
        {Array.from({ length: TOTAL_ADS }).map((_, index) => {
          const adId = index + 1;

          const isCompleted = user?.adsCompleted?.includes(adId);
          const isUnlocked = adId <= unlockedAdsCount;

          return (
            <div key={adId} style={styles.card}>
              <div>
                <h4 style={{ margin: 0 }}>Ads #{adId}</h4>
                {isCompleted && timeLeft[adId] && (
                  <small style={{ color: "#dc2626" }}>
                    Unlocks in: {timeLeft[adId]}
                  </small>
                )}
              </div>

              <div style={styles.right}>
                <span style={styles.amount}>৳10.00</span>
                <button
                  style={{
                    ...styles.btn,
                    background: isCompleted ? "#16a34a" : isUnlocked ? "#06b6d4" : "#9ca3af",
                    cursor: isCompleted || !isUnlocked ? "not-allowed" : "pointer",
                  }}
                  disabled={!isUnlocked || isCompleted}
                  onClick={() => handleViewAds(adId)}
                >
                  {isCompleted ? "Complete 🔒" : isUnlocked ? "View Ads" : "Locked 🔒"}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MyTask;

const styles = {
  page: { minHeight: "100vh", background: "#f2f2f2", padding: 15 },
  header: {
    background: "#7a0f7a",
    color: "#fff",
    padding: "15px",
    marginBottom: 15,
    borderRadius: 10,
  },
  list: { display: "flex", flexDirection: "column", gap: 10 },
  card: {
    background: "#fff",
    borderRadius: 15,
    padding: 20,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
  },
  right: { textAlign: "right" },
  amount: {
    display: "block",
    color: "#0ea5e9",
    fontWeight: 700,
    marginBottom: 8,
  },
  btn: {
    color: "#fff",
    border: "none",
    padding: "8px 14px",
    borderRadius: 10,
    fontWeight: 600,
  },
};